module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-diamond-9c3ae3d3.svg";